import { Commit } from 'vuex';
import { IVuexStore } from '.';
import axios, { AxiosResponse } from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

interface ContactDetails {
    firstName: string;
    lastName: string;
    email: string;
}

export const actions = {
    getForm: async ({ state, commit }: { state: IVuexStore; commit: Commit }, formId: number) => {
        commit('setLoading', true);
        try {
            const { data } = await axios({
                method: 'GET',
                url: `${API_URL}/client/form/get/${formId}`,
            });

            if (state.updated && state.updated < data.form.updated) {
                commit('restart');
            }

            commit('setForm', data.form);

            return Promise.resolve(data.form);
        } catch (err) {
            const error = err.toString();
            commit('addError', error);
            return Promise.reject(error);
        } finally {
            commit('setLoading', false);
        }
    },
    auth: async (
        { state, commit }: { state: IVuexStore; commit: Commit },
        { contact }: { contact: null | ContactDetails },
    ) => {
        commit('setLoading', true);
        try {
            const id = state.form && state.form.id;
            const { data } = await axios({
                url: `${API_URL}/client/entry/create/${id}`,
                method: 'POST',
                data: contact,
            });
            commit('setAccessCode', data.accessCode);
            return Promise.resolve(data.accesCode);
        } catch (err) {
            let error = err.toString();
            if (err.response.status === 403) {
                error = 'E-mail already exists in database.';
            }
            commit('addError', error);
            return Promise.reject(error);
        } finally {
            commit('setLoading', false);
        }
    },
    submit: async ({ state, commit }: { state: IVuexStore; commit: Commit }) => {
        commit('setLoading', true);
        try {
            const id = state.form && state.form.id;
            const { data }: AxiosResponse = await axios({
                url: `${API_URL}/client/entry/submit/${id}`,
                method: 'POST',
                headers: {
                    accessCode: state.accessCode,
                },
                data: state.answers,
            });

            if (data.form) {
                if (state.updated && state.updated < data.form.updated) {
                    commit('restart');
                }
                commit('setForm', data.form);
            }
            if (data.next) {
                commit('addElement', data.next);
            }
            if (data.report) {
                commit('setReport', data.report);
            }

            return Promise.resolve();
        } catch (err) {
            const error = err.toString();
            commit('addError', err.toString());
            return Promise.reject(error);
        } finally {
            commit('setLoading', false);
        }
    },
    send: async ({ state }: { state: IVuexStore; commit: Commit }, { email }: { email: string }) => {
        try {
            const id = state.form && state.form.id;
            await axios({
                method: 'POST',
                url: `${API_URL}/client/entry/report_send/${id}`,
                headers: {
                    accessCode: state.accessCode,
                },
                data: {
                    email,
                },
            });

            return Promise.resolve();
        } catch (err) {
            return Promise.reject(err.toString());
        }
    },
    report: async ({ state, commit }: { state: IVuexStore; commit: Commit }, id: number) => {
        try {
            const { data } = await axios({
                method: 'POST',
                url: `${API_URL}/client/entry/report/${id}`,
                headers: {
                    accessCode: state.accessCode,
                },
            });
            commit('setForm', data.form);
            commit('setReport', data.report);

            return Promise.resolve();
        } catch (err) {
            return Promise.reject(err.toString());
        }
    },
};
